export default __webpack_public_path__ + "static/media/book cover@2x.d9d8854c.png";